import { useCallback } from "react";
import useGetWorkOrder from "../useGetWorkOrder";
import { addFollowup } from "../../api/Events";

export default function useAttachFollowupWo() {
  const { trigger } = useGetWorkOrder();
  const attachFollowupWo = useCallback(
    async (woNumber: string, followupWo: string) => {
      const woResponse = await trigger(woNumber);
      const followUpData = {
        baseWo: woResponse.data?.Events?.WoBase,
        followUpDateCreated: woResponse.data?.Events?.FollowUpOfDate,
        followUpTimeCreated: woResponse.data?.Events?.FollowUpOfTime,
        followupWo,
        isBaseWorkOrder: true,
        isFollowUpWo: true,
      };
      addFollowup(followUpData);
    },
    [trigger]
  );

  return { attachFollowupWo };
}
